import React, { useState, useRef, useEffect } from "react"
import { Upload, X, Check, AlertCircle, Loader2, Trash2, Save, AlertTriangle } from "lucide-react"
import { Button, Badge, Input, message, useCRUDController, Row, Col } from "../../ui/ot"
import StatsCard from "../../ui/stats-card"
const ChartCirculationStatscard = ({
    propsDataParams = null,
    propsEnableAnimation = true,
    propsCardSize = "md",
    propsContentAlign = "center",
    propsBackgroundColor = "bg-white",
    propsLabel = null,
    propsColor = "#1976d2",
    apiRoute = "/koha/report/item/total",
    rowKey = "item_total_number",
    getLabel = () => { return "" }
}) => {
    const [data, setData] = useState([
        {
            value: 0,
            label: "館藏總量",
            color: "#1976d2",
            // backgroundColor: "bg-purple-100",
            animationDuration: 2000,
            animationDelay: 0,
        }
    ])
    const [loading, setLoading] = useState(false)
    const dataController = useCRUDController({ apiRoute: apiRoute })
    const getData = () => {
        setLoading(true)
        dataController.getData({
            ...propsDataParams
        }).then((response) => {
            setLoading(false)
            let data = response?.data
            let firstData = data?.find((ele) => true)
            if (!!firstData) {
                setData([{
                    value: firstData?.[rowKey] || 0,
                    label: propsLabel || getLabel(firstData),
                    color: propsColor,
                    // backgroundColor: "bg-purple-100",
                    animationDuration: 2000,
                    animationDelay: 0,
                }])
            }
        })
    }
    useEffect(() => {
        getData()
    }, [propsDataParams])


    return (<Row>
        <Col span={24}>
            <StatsCard
                layout="horizontal"
                stats={data}
                enableAnimation={propsEnableAnimation}
                isLoading={loading}
                loadingDuration={1500}
                size={propsCardSize}
                contentAlign={propsContentAlign}
                backgroundColor={propsBackgroundColor}
                connection={'separated'}
                columnsPerRow={1}
            />
        </Col>
    </Row>)
}
export { ChartCirculationStatscard }